module.exports = __webpack_public_path__ + "img/straightLineWhite.73d71f8f.svg";